import {
    IntentKind,
    makeIntentBuilderFunction,
    makeIntentGuard,
    type RouteableIntent,
} from '@jet-app/music-classical/intents';

export interface BrowseDetailPageIntent extends RouteableIntent {
    $kind: IntentKind.BROWSE_DETAIL_PAGE;
    entityType: string;
    entityPath?: string;
    id?: string;
    metadata?: any;
}

export const isBrowseDetailPageIntent = makeIntentGuard<BrowseDetailPageIntent>(
    IntentKind.BROWSE_DETAIL_PAGE,
);
export const makeBrowseDetailPageIntent =
    makeIntentBuilderFunction<BrowseDetailPageIntent>(
        IntentKind.BROWSE_DETAIL_PAGE,
    );
